import { render, staticRenderFns } from "./BOMBaseInfo.vue?vue&type=template&id=8183d898&"
import script from "./BOMBaseInfo.vue?vue&type=script&lang=js&"
export * from "./BOMBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BOMBaseInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports